import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-tips"
}, [/*#__PURE__*/_createElementVNode("div", null, "手机端访问体验更佳"), /*#__PURE__*/_createElementVNode("div", null, "立即扫码👇"), /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/pc-home-code.png",
  alt: ""
})], -1);

import { onBeforeMount, onMounted, onUpdated } from "vue";
import { initWxJssdk } from "@/assets/utils/common.utils";
import wx from "weixin-js-sdk";
export default {
  __name: 'App',

  setup(__props) {
    onBeforeMount(() => {});
    onMounted(() => {
      initWxJssdk();
    });
    onUpdated(() => {
      initWxJssdk();
    });
    initWxJssdk(() => {
      var title = "极客公园创新大会 2023 来了！";
      var desc = "2022 最值得期待的科技盛会，12.17 - 12.18 在深圳等你！";
      var url = "https://if.geekpark.net/home";
      var imgUrl = "https://summit-img.geekpark.net/if2023/logo_196.png"; //新版分享API

      wx.updateAppMessageShareData({
        title: title,
        // 分享标题
        desc: desc,
        // 分享描述
        link: url,
        // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: imgUrl // 分享图标
        // success: function () {
        //   // 设置成功
        //   console.log('分享给朋友设置成功');
        // }

      });
      wx.updateTimelineShareData({
        title: title,
        desc: desc,
        // 分享描述
        link: url,
        imgUrl: imgUrl
      });
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _hoisted_1], 64);
    };
  }

};